<template>
  <b-modal
    size="lg"
    scrollable
    no-fade
    no-close-on-esc
    no-close-on-backdrop
    id="modal-edit-upload"
    ref="modal-edit-upload"
    title="Alterar dados"
  >
    <b-row>
      <b-col lg="12">Arquivo: {{ file.nome_arquivo }}</b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-form-group label-size="sm" label="Observações" label-for="obs">
          <b-form-textarea id="obs" v-model="file.observacoes" rows="3" no-resize></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="2">
        <b-form-group label-size="sm" label="Versão" label-for="versao">
          <b-form-input type="number" id="versao" v-model="file.versao"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group label-size="sm" label="Ano" label-for="ano">
          <b-form-input type="number" id="ano" v-model="file.ano"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label-size="sm" label="Mês" label-for="mes">
          <v-select
            append-to-body
            id="mes"
            :options="[{ label: 'Janeiro', id: 1}, { label: 'Fevereiro', id: 2}, 
                        { label: 'Março', id: 3}, { label: 'Abril', id: 4},
                        { label: 'Maio', id: 5}, { label: 'Junho', id: 6},
                        { label: 'Julho', id: 7}, { label: 'Agosto', id: 8},
                        { label: 'Setembro', id: 9}, { label: 'Outubro', id: 10},
                        { label: 'Novembro', id: 11}, { label: 'Dezembro', id: 12}]"
            label="label"
            :reduce="tip => tip.id"
            :clearable="false"
            :searchable="false"
            v-model="file.mes"
          ></v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button @click="saveUpload()" size="sm" variant="primary">
        <i class="fas fa-check"></i> Gravar
      </b-button>
      <b-button size="sm" @click="() => $bvModal.hide('modal-edit-upload')">Cancelar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "ModalEditUpload",
  props: ["file"],
  methods: {
    saveUpload() {
      axios
        .put(`${baseApiUrl}/arquivos/${this.file.arquivo_id}`, this.file)
        .then(() => {
          this.$emit("updateComplete");
          this.$bvModal.hide("modal-edit-upload");
        })
        .catch(err => showError(err));
    }
  },
  mounted() {}
};
</script>

<style>
.vs__dropdown-menu{
  z-index: 100000;
}
</style>